import {requestInstance} from "@/app/[locale]/config/requestInstance";
import RegisterModel from "@/app/services/models/RegisterModel";

class RegisterService {
    api = {
        register: '/register',
        emailAvailability: '/check-email-availability'
    }

    register(data) {
        return requestInstance.post(this.api.register, data)
            .then(r => {
                return new RegisterModel(r.data);
            })
            .catch(err => Promise.reject(err));
    }

    checkEmailAvailability(email) {
        const params = {email: email};
        return requestInstance.get(this.api.emailAvailability, {params})
            .then(r => r.data)
            .catch(err => Promise.reject(err));
    }
}

export const registerService = new RegisterService();